import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { StatesEntity } from './states.entity';
import { CommonResponse } from '@gtpl/shared-models/production-management';


@Injectable()
export class StatesService {
  constructor(
    @InjectRepository(StatesEntity)
    private readonly statesRepository: Repository<StatesEntity>,
  ) {}

  async getAllStates(): Promise<CommonResponse> {
    const data = await this.statesRepository.find();
    if(data){
        return new CommonResponse(true,1,'data retrived',data)
    }
  }
}
